<template>
    <div>
        <nav-header></nav-header>
        <div class="projectdashboard-form validate-form p-l-50 p-r-50 p-t-10 p-b-80" >
            <section>
                <div class="page-title">
                    <h2>Administração</h2>
                </div>
                <hr/>
                <b-container>
                    <b-row>
                        <b-col>
                            <Dropdown
                            :options="companies"
                            :disabled="false"
                            :maxItem="10"
                            v-on:selected="validateCompanySelection"
                            placeholder="Selecione uma empresa">
                            </Dropdown>
                        </b-col>
                        <b-col>
                            <Dropdown
                            :key="componentKey"
                            :options="projects"
                            :disabled="false"
                            :maxItem="10"
                            v-on:selected="validateProjectSelection"
                            placeholder="Selecione um projeto">
                            </Dropdown>
                        </b-col>                      
                    </b-row>
                </b-container>
                <dashboard
                :companyId="selectedCompany"
                :projectId="selectedProject"
                >
                </dashboard>                
            </section>
            
        </div>
        
        <user-profile-footer></user-profile-footer>
    </div>   
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
    .dropdown-content {
        z-index: 10 !important;
    }
</style>

<script>
    import axios from "axios";
    import config from "../helpers/generalConfig";
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue'
    import Dropdown from '../components/DropdownSearch.vue';
    import Dashboard from '../components/Dashboard.vue'; 

    export default {
        components:{ NavHeader, UserProfileFooter, Dropdown, Dashboard },

        data() {
            return {
                selectedCompany: null,
                selectedProject: null,
                companies: [],
                projects: [],
                componentKey: 0
            }
        },

        watch: {
            selectedCompany: function() {
                this.refreshProjects()
                this.getProjects()
            }
        },

        mounted() {
            this.getCompanies();
        },

        methods: {
            refreshProjects(){
                this.componentKey += 1
            },

            getCompanies() {
                axios
                    .get(`${config.jsonServer}/company`, this.headers())
                    .then(comps => {
                    this.companies = comps.data.map(c => {
                        return {
                        id: c.id_empresa,
                        name: c.nome_empresa
                        }
                    })
                    });
            },
            
            getProjects() {
                axios
                    .get(`${config.jsonServer}/project/company/${this.selectedCompany}`, this.headers())
                    .then(projs => {
                    var options = [{id: 0,  name: ""}]
                    this.projects = options.concat(projs.data.map(p => {
                        return {
                        id: p.id_projeto,
                        name: p.nome_projeto
                        }
                    }))
                    
                    });
                    
            },

            validateCompanySelection(selected) {
                this.selectedProject = null
                this.projects = []
                if('id' in selected)
                    this.selectedCompany = selected.id;                
            },

            validateProjectSelection(selected) {
                if('id' in selected)
                    this.selectedProject = selected.id;                
            },

            headers() {
                const token = this.$store.getters["auth/token"].token;
                return { headers: { Authorization: "Bearer " + token } };
            },

            isAdminCEPE() {
                return this.$store.getters['auth/user'].Role === 'ADMIN_CEPE';
            },
        },

        
    }
</script>